import { type ComponentProps, type ComponentType, type ReactNode, memo, useMemo } from 'react'

import { withDroppable } from '@/components/enhancers/withDroppable.tsx'
import type { StoryForm } from '@/components/form/StoryForm.tsx'
import { TEMPORARY_ID_PREFIX } from '@/constants/PREFIX.ts'
import { useAttachment } from '@/contexts/AttachmentContext.tsx'

export const withStoryDropzone = (WrappedComponent: ComponentType<ComponentProps<typeof StoryForm>>) => {
  return memo(function StoryDropzone(props: ComponentProps<typeof StoryForm>) {
    const { addAttachment } = useAttachment()

    const DroppableComponent = useMemo(
      () =>
        withDroppable(({ children }: { children: ReactNode }) => <section className="bg-white">{children}</section>, {
          onDrop: (files) => addAttachment(files, props.storyId, `${TEMPORARY_ID_PREFIX}${props.storyId}`),
        }),
      [props.storyId, addAttachment],
    )

    return (
      <DroppableComponent>
        <WrappedComponent {...props} />
      </DroppableComponent>
    )
  })
}
